import {Component, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {GetSetDataService} from '../../services/get-set-data.service';
import {NgForOf, NgIf} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SearchSimplePipe} from '../pipes/search-simple.pipe';
import {LoaderComponent} from '../loader/loader.component';
import {HighlightPipe} from '../pipes/highlight.pipe';

@Component({
  selector: 'app-faq-standalone',
  templateUrl: './faq-standalone.component.html',
  imports: [
    NgIf,
    FormsModule,
    SearchSimplePipe,
    NgForOf,
    LoaderComponent,
    HighlightPipe
  ],
  styleUrls: ['./faq-standalone.component.scss']
})
export class FaqStandaloneComponent implements OnInit {

  public data?: any;
  public searchValue?: any;
  public areAllOpen?: boolean;

  constructor(private getsetData: GetSetDataService, public sanitizer: DomSanitizer) {
  }

  async ngOnInit() {
    this.data = await this.getsetData.getFaqContent();
  }

  public activeFaqView(item: any) {
    item['isOpen'] = !item['isOpen'];
  }

  public handleInputChange() {
    if (this.searchValue.length > 0) {
      this.openAll(true);
    } else {
      this.openAll(false);
    }
  }

  public expandAll(): any {
    if (this.areAllOpen) {
      for (const item of this.data) {
        item['isOpen'] = false;
      }
      this.areAllOpen = false;
      return false;
    }

    this.areAllOpen = true;

    this.openAll(true);
  }

  private openAll(status: boolean) {
    for (const item of this.data) {
      item['isOpen'] = status;
    }
  }
}
